import React from 'react';
import { Box, Typography } from '@mui/material';

import { v2Colors } from '../../design/theme';

const FREE_DELIVERY_THRESHOLD = 999;

export default function FreeDeliveryPromotion({ totalAmount }) {
  const cartTotal = Math.round(Number(totalAmount) || 0);

  if (cartTotal <= 0) {
    return null;
  }

  if (cartTotal >= FREE_DELIVERY_THRESHOLD) {
    return (
      <Box
        sx={{
          my: 2,
          p: 1.5,
          bgcolor: v2Colors.surface,
          border: `2px solid ${v2Colors.primary}`,
          borderRadius: 2,
          textAlign: 'center',
        }}
      >
        <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: v2Colors.primary }}>
          Congratulations! You got FREE delivery!
        </Typography>
      </Box>
    );
  }

  const remainingAmount = FREE_DELIVERY_THRESHOLD - cartTotal;
  if (remainingAmount <= 0) {
    return null;
  }

  const progressPct = Math.min(Math.max((cartTotal / FREE_DELIVERY_THRESHOLD) * 100, 0), 100);

  return (
    <Box
      sx={{
        my: 2,
        py: 1,
        px: 1.5,
        bgcolor: v2Colors.surface,
        border: `2px solid ${v2Colors.primary}`,
        borderRadius: 2,
        textAlign: 'center',
      }}
    >
      <Typography sx={{ fontSize: '0.875rem', color: v2Colors.heading, mb: 0.5 }}>
        Add products worth{' '}
        <Box component="span" sx={{ fontWeight: 700, color: v2Colors.primary, fontSize: '1rem' }}>
          ₹{remainingAmount}
        </Box>{' '}
        more to get{' '}
        <Box component="span" sx={{ fontWeight: 700, color: v2Colors.primary }}>
          FREE delivery!
        </Box>
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
        <Box
          sx={{
            flex: 1,
            height: 4,
            bgcolor: 'rgba(0,0,0,0.12)',
            borderRadius: 1,
            position: 'relative',
            overflow: 'visible',
          }}
        >
          <Box
            sx={{
              height: '100%',
              width: `${progressPct}%`,
              bgcolor: v2Colors.primary,
              borderRadius: 1,
              transition: 'width 0.3s ease',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: `${progressPct}%`,
              transform: 'translate(-50%, -50%)',
              width: 12,
              height: 12,
              bgcolor: v2Colors.primary,
              borderRadius: '50%',
              border: '2px solid white',
              boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
              transition: 'left 0.3s ease',
            }}
          />
        </Box>
        <Typography sx={{ fontSize: '0.7rem', color: v2Colors.textMuted, whiteSpace: 'nowrap' }}>
          ₹{cartTotal} / ₹{FREE_DELIVERY_THRESHOLD}
        </Typography>
      </Box>
    </Box>
  );
}
